import { render, staticRenderFns } from "./CardUserAuth.vue?vue&type=template&id=2504db06&scoped=true"
import script from "./CardUserAuth.vue?vue&type=script&lang=js"
export * from "./CardUserAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2504db06",
  null
  
)

export default component.exports